/**
 * Complejidad de contrasena de `imprenta` (ADR 0104 §2.6): 8+ caracteres, una
 * mayuscula, una minuscula, un digito y un caracter especial.
 *
 * Vive aca —data pura, invariante 2— para que el worker la exija en
 * `/reset-password` y `/change-password` y el dashboard valide igual antes de
 * enviar. El techo de 128 no es de esta regla: lo pone Better Auth.
 */

export const MENSAJE_CONTRASENA_DEBIL =
  "La contraseña debe tener: 8+ caracteres, mayúscula, minúscula, número y carácter especial";

export const LARGO_MINIMO_CONTRASENA = 8;

/** El conjunto de `imprenta` (`backend/app/schemas/user.py`), literal. */
const ESPECIAL = /[!@#$%^&*(),.?":{}|<>\-_=+[\]\\;'`~]/;

/** Por que una contrasena no sirve, o `null` si cumple las cinco reglas. */
export function problemaDeContrasena(password: string): string | null {
  const cumple =
    password.length >= LARGO_MINIMO_CONTRASENA &&
    /[A-Z]/.test(password) &&
    /[a-z]/.test(password) &&
    /[0-9]/.test(password) &&
    ESPECIAL.test(password);
  return cumple ? null : MENSAJE_CONTRASENA_DEBIL;
}
